import { combineReducers } from 'redux';
import patientSearch from './patientSearch';

const reducer = combineReducers({
	patientSearch,
});

export default reducer;
